import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import { resetStore } from "./store";
import { getDatarouterConfig } from "../settings/store";
import { warn } from "../infra/effects";

export const createResetApi =
  (
    db: MarlinStoreDb,
    { files, updater }: Pick<HostCapabilities, "files" | "updater">,
    screenId: number,
  ) =>
  async () => {
    const result = await resetStore(db, [screenId]);
    await files?.removeIpJson().catch(warn("ip.json removal"));
    await updater
      ?.applyDatarouterConfig(await getDatarouterConfig(db))
      .catch(warn("datarouter apply"));
    return result;
  };
